import { DatePicker } from 'antd'
import MultiSelect from '../common/FormControls/MultiSelect'
import dayjs, { Dayjs } from 'dayjs'
import { ReactNode } from 'react'
const { RangePicker } = DatePicker

type FilterCategory = {
  key: string
  label: string
  all: boolean
  values: {
    name: string
    value: number
    selected: boolean
  }[]
}

type Props = {
  jobTypes: FilterCategory
  statuses: FilterCategory
  visitStatuses: FilterCategory
  divisions: FilterCategory
  startDate: Dayjs | null
  endDate: Dayjs | null

  onFilterChange: (filterName: string, selectedValues: number[]) => void
  onDateRangeChange: (startDate: string | null, endDate: string | null) => void
  counter: number
  startAddition?: ReactNode
  endAddition?: ReactNode
}

const BillingPageFilters = ({ jobTypes, statuses, visitStatuses, divisions, startDate, endDate, onFilterChange, onDateRangeChange, startAddition, endAddition }: Props) => {
  return <div
    style={{
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      gap: 16,
      alignItems: 'flex-start',
      flexWrap: 'wrap'
    }}
  >
    {startAddition}
    <div>
      <div>Job Type</div>
      <MultiSelect
        options={jobTypes.values.map(x => ({ label: x.name, value: x.value }))}
        selectedValues={jobTypes.values.filter(x => x.selected).map(x => x.value)}
        onChange={selectedValues => onFilterChange('projectType', selectedValues)}
        placeholder="Select job types"
        allSelectedText="All Job Types"
        maxTagCount={4}
        style={{ width: 200 }}
      />
    </div>
    <div>
      <div>Work Area Status</div>
      <MultiSelect
        options={statuses.values.map(x => ({ label: x.name, value: x.value }))}
        selectedValues={statuses.values.filter(x => x.selected).map(x => x.value)}
        onChange={selectedValues => onFilterChange('scheduledStatus', selectedValues)}
        placeholder="Select statuses"
        allSelectedText="All Statuses"
        maxTagCount={4}
        style={{ width: 200 }}
      />
    </div>
    <div>
      <div>Visit Status</div>
      <MultiSelect
        options={visitStatuses.values.map(x => ({ label: x.name, value: x.value }))}
        selectedValues={visitStatuses.values.filter(x => x.selected).map(x => x.value)}
        onChange={selectedValues => onFilterChange('invoicedStatus', selectedValues)}
        placeholder="Select visit statuses"
        allSelectedText="All Visit Statuses"
        maxTagCount={4}
        style={{ width: 200 }}
      />
    </div>
    <div>
      <div>Division</div>
      <MultiSelect
        options={divisions.values.map(x => ({ label: x.name, value: x.value }))}
        selectedValues={divisions.values.filter(x => x.selected).map(x => x.value)}
        onChange={selectedValues => onFilterChange('divisions', selectedValues)}
        placeholder="Select divisions"
        allSelectedText="All Divisions"
        maxTagCount={4}
        style={{ width: 200 }}
      />
    </div>
    <div>
      <div>Dates</div>
      <RangePicker
        value={[startDate ? dayjs(startDate) : null, endDate ? dayjs(endDate) : null]}
        onChange={(range) => {
          if (range) {
            onDateRangeChange(range[0]?.format('MM/DD/YYYY') ?? null, range[1]?.format('MM/DD/YYYY') ?? null)
          } else {
            onDateRangeChange(null, null)
          }
        }}
      />
    </div>
    {endAddition && <div style={{ marginLeft: 'auto', alignSelf: 'center' }}>{endAddition}</div>}
  </div>
}

export default BillingPageFilters